
























import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { IColorSpecifiable, instanceOfIEnableSpecifiable } from "../../../../../../../base/domain/drawing";
import { IRollOption } from "../../../../../../../documaker/domain/format/objects";

@Component
export default class RollOptionSelector extends Mixins() {
  @Prop({ default: () => [] as IRollOption[] })
  options: IRollOption[];

  $refs!: {
    table: ElTable,
  };

  sizeStyleProperties() {
    return {
      width: "20px",
      height: "20px",
    };
  }

  colorStyleProperties(style: IColorSpecifiable) {
    return ((!instanceOfIEnableSpecifiable(style) || style.isEnable) && (style.color.value !== null))
      ? {
        backgroundColor: style.color.value,
        border: "1px solid",
        borderColor: "inherit",
      }
      : null;
  }

  @Watch("options")
  onOptionsUpdated(newValue: IRollOption[], oldValue: IRollOption[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: IRollOption[]): void {}
}
